import { render, staticRenderFns } from "./jobOffers-add-or-edit.vue?vue&type=template&id=25314fae&scoped=true&class=newList&"
import script from "./jobOffers-add-or-edit.vue?vue&type=script&lang=js&"
export * from "./jobOffers-add-or-edit.vue?vue&type=script&lang=js&"
import style0 from "./jobOffers-add-or-edit.vue?vue&type=style&index=0&id=25314fae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25314fae",
  null
  
)

export default component.exports